import { render, staticRenderFns } from "./pi-add-producer.vue?vue&type=template&id=51884544"
import script from "./pi-add-producer.vue?vue&type=script&lang=ts"
export * from "./pi-add-producer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports